import React, { FC, useState } from 'react'

import { Icon, Modal, StandardButton, Txt } from 'src/components/atoms'

import { useCommonContentPage, useGetCommonContentPages, useToast } from 'src/hooks'
import { CommonContentPageEntity } from 'src/types'

type Props = {
  commonContent: CommonContentPageEntity
  isOpen: boolean
  onClose: () => void
  afterDelete?: () => void
}

export const DeleteCommonContentPageModal: FC<Props> = ({
  commonContent,
  isOpen,
  onClose,
  afterDelete,
}) => {
  const [isDeleting, setIsDeleting] = useState(false)

  const { deleteCommonContentPage } = useCommonContentPage()
  const { refetch } = useGetCommonContentPages()
  const { displayStandardTextToast, displayErrorTextToast } = useToast()

  const handleOnDelete = async () => {
    setIsDeleting(true)

    try {
      await deleteCommonContentPage({ commonContentPageId: commonContent.id })
      refetch()
      displayStandardTextToast('共通コンテンツを削除しました')
    } catch {
      displayErrorTextToast('共通コンテンツの削除に失敗しました。')
    } finally {
      setIsDeleting(false)
      onClose()
      afterDelete && afterDelete()
    }
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      maxWidth="md"
      headerInner={
        <div className="tw-px-s1">
          <div className="tw-flex tw-items-center">
            <Icon size="--r1" path="trash/soft/line" className="tw-accent-standardText-secondary" />
            <Txt sizeType="l" className="tw-ml-r-3 tw-font-bold">
              共通コンテンツ削除
            </Txt>
          </div>
        </div>
      }
    >
      <div className="tw-w-[39.14rem] tw-p-s2">
        <Txt>
          共通コンテンツ削除を実行すると情報の復元はできません。ROOV
          compassプレゼンツールや、お客様へシェア済の共通コンテンツが即時配信されなくなります。本当によろしいですか？
        </Txt>

        <div className="tw-centering tw-mt-s3">
          <StandardButton
            buttonType="secondary"
            text="キャンセル"
            prependIconPath="close/soft/line"
            size="l"
            onClick={onClose}
          />
          <StandardButton
            buttonType="danger"
            text="削除"
            prependIconPath="trash/soft/line"
            isLoading={isDeleting}
            size="l"
            onClick={handleOnDelete}
            className="tw-ml-s2"
          />
        </div>
      </div>
    </Modal>
  )
}
